<!--
* @description  Cascader 级联选择器
* @fileName  Cascader-panel
* @author zlj
* @date 2022-06-02 11:24:18
!-->
<template>
  <div id="Cascader-panel" class="Cascader-panel" ref="casPanel">
    <div class="selector-box">
      <div class="selector-box-item flex1" v-if="!isOpenSeach">
        <section class="">
          <el-scrollbar class="scroll_menu" :style="{ width: widthOne + 'px' }">
            <ul class="selector-menu" :style="{ width: widthOne + 'px' }">
              <li
                v-for="(item, index) in selectData.lenght > 0 ? selectData : cascadeList"
                :key="index"
                class="flex flex_space selector-one-item"
                @click="clkTitleBtn(item, index)"
                @mouseenter="clkTitleBtn(item, index)"
              >
                <div class="maR_l8" :class="{ 'text-active-color': isSle(item.label) }">
                  {{ item.label }}
                </div>
                <div>
                  <i class="fa tf_arrow_right">
                    <iconComm
                      :iconNameCard="
                        isSle(item.label)
                          ? 'icon-xiala text-active-color'
                          : 'icon-xiala font_c777'
                      "
                      size="16"
                    ></iconComm>
                  </i>
                </div>
              </li>
            </ul>
          </el-scrollbar>
        </section>

        <section class="flex1" v-show="isTreeOne && showText">
          <div class="divider_line"></div>
          <el-scrollbar class="scroll_menu_one">
            <ul class="selector-menu-one" v-show="showText == 1">
              <li
                v-for="(item, index) in pickupCityData"
                :key="index"
                class="flex flex_space selector-one-item"
                @click="clkCityText(item)"
                @mouseenter="clkCityText(item)"
              >
                <div class="maR_l8" :class="{ 'text-active-color': isSle(item.CityKey) }">
                  {{ item.NameCh }}
                </div>
                <div>
                  <i class="fa tf_arrow_right">
                    <iconComm
                      :iconNameCard="
                        isSle(item.CityKey)
                          ? 'icon-xiala text-active-color'
                          : 'icon-xiala font_c777'
                      "
                      size="16"
                      iconColor="#777777"
                    ></iconComm>
                  </i>
                </div>
              </li>
            </ul>

            <ul class="selector-menu-one" v-show="showText == 2">
              <li
                v-for="(item, index) in ThProvData"
                :key="index"
                class="flex flex_space selector-one-item"
                @click="clkPro(item)"
                @mouseenter="clkPro(item)"
              >
                <div
                  class="maR_l8"
                  :class="{ 'text-active-color': isSle(item.Province.Province_NameCh) }"
                >
                  {{ item.Province.Province_NameCh }}
                </div>
                <div>
                  <i class="fa tf_arrow_right">
                    <iconComm
                      :iconNameCard="
                        isSle(item.Province.Province_NameCh)
                          ? 'icon-xiala text-active-color'
                          : 'icon-xiala font_c777'
                      "
                      size="16"
                      iconColor="#777777"
                    ></iconComm>
                  </i>
                </div>
              </li>
            </ul>
          </el-scrollbar>
        </section>

        <section class="flex1" v-show="ThCityList.length">
          <div class="divider_line"></div>
          <el-scrollbar class="scroll_menu_one">
            <ul class="selector-menu-one">
              <li
                v-for="(item, index) in ThCityList"
                :key="index"
                class="flex flex_space selector-one-item"
                :style="item.AreaList.length === 0 ? 'color:#333333' : ''"
                @click="clkCitySelect(item)"
                @mouseenter="clkCitySelect(item)"
              >
                <div class="maR_l8" :class="{ 'text-active-color': isSle(item.Id) }">
                  {{ item.City_NameCh }}
                </div>

                <div v-show="item.AreaList.length > 0">
                  <i class="fa tf_arrow_right">
                    <iconComm
                      :iconNameCard="
                        isSle(item.Id)
                          ? 'icon-xiala text-active-color'
                          : 'icon-xiala font_c777'
                      "
                      size="16"
                      iconColor="#777777"
                    ></iconComm>
                  </i>
                </div>
              </li>
            </ul>
          </el-scrollbar>
        </section>

        <section class="flex1" v-show="ThAreaData.length">
          <div class="divider_line"></div>
          <el-scrollbar class="scroll_menu_one">
            <ul class="selector-menu-one">
              <li
                v-for="(item, index) in ThAreaData"
                :key="index"
                class="flex flex_space selector-one-item"
                style="color: #333333"
                @click="clkAreaSelect(item)"
              >
                <div class="maR_l8" :class="{ 'text-active-color': isSle(item.Id) }">
                  {{ item.CityArea_NameCh }}
                </div>
              </li>
            </ul>
          </el-scrollbar>
        </section>
      </div>
      <Seach-panel
        padding="8"
        :options="getProvSearch"
        optionKey="citySelName"
        @click="clickSeach"
        v-if="isOpenSeach"
      ></Seach-panel>
    </div>
  </div>
</template>

<script>
import bus from "@/ask/eventBus";
import { fetch, post } from "@/ask/axios";
export default {
  props: {
    // 父辈向子辈传参

    // 选择级项
    selectData: {
      type: [Array],
      default: () => [],
    },

    // 选中名称
    selectIdxName: {
      type: [Array],
      default: () => [],
    },
    // 一级宽度样式
    widthOne: {
      type: [String, Number],
      default: "",
    },
    // 是否开启搜索功能
    isOpenSeach: {
      type: [Boolean],
      default: false,
    },
  },
  name: "Cascader-panel",
  data() {
    return {
      pickupCityData: [], //常用市区数据
      ThAreaData: [], //省/直辖市
      ThProvData: [], //省/直辖市
      ThCityList: [], //省/直辖市
      getProvSearch: [], //搜索相关省市区
      isSearchTxt: 0, //是否 开启搜索

      showText: null, //
      isTreeOne: true,
      CityText: "",
      cityInput: "",

      //省份数据保存
      ProvDate: { ProvNameEn: "", ProvNameCh: "", ProvKey: "" },
      CityDate: { CityNameEn: "", CityNameCh: "", CityKey: "" },
      AreaData: { AreaNameEn: "", AreaNameCh: "", AreaKey: "" },

      ProvDateBF: { ProvNameEn: "", ProvNameCh: "", ProvKey: "" },
      CityDateBF: { CityNameEn: "", CityNameCh: "", CityKey: "" },

      /**
       * 级联数组
       * **/
      cascadeList: [
        {
          value: "changyongchi",
          label: "常用市",
        },
        {
          value: "shengzhixiashi",
          label: "省/直辖市",
        },
      ],
      idxSelect: null, //选择项

      menuNameChIdx: [], //选中集合

      menuCh: "",

      isThCity: false, //搜索框 市级展示
      isThAreaData: false, //搜索框 区级展示
    };
  },
  async asyncData({ app, query, req }) {
    // let ceshi = []
    // let url
    // url = app.$api01 + "/api/InfoCustomer/Attribute/QueryThHotCity"
    // let aaa = await fetch(url, {})
    // ceshi = aaa.Results
    // return {
    //   ceshi
    // }
  },
  created() {
    // 实例被创建之后执行代码
  },
  computed: {
    // 计算属性
  },
  components: {
    // 组件的引用
  },
  methods: {
    // 方法
    // 是否选中
    isSle(item) {
      // console.log(item, "是否选中", this.menuNameChIdx);
      let arrIsSelect = this.menuNameChIdx;
      return arrIsSelect ? arrIsSelect.indexOf(item) != -1 : false;
    },

    // 无层级
    // setTree(data, str = 0) {
    //   return data.filter((item) => {
    //     if (item.pid === str) {
    //       if (item.id) {
    //         item.children = this.setTree(data, item.id)
    //         return true
    //       }
    //     }
    //   })
    // },
    clkTitleBtn(item, index) {
      //点击标题，进行切换常用城市、省、市
      this.menuCh = item.label;

      this.setTree(index, 1);
      /**
       * 0.常用市区， 1.省市区
       * **/
      switch (index) {
        case 0:
          this.showText = 1;
          break;
        case 1:
          this.showText = 2;
          break;
        default:
          "";
      }

      this.$emit("cityCut", index);
    },
    //常用市区接口
    async getThHotCityApi() {
      let getThHotCityUrl = this.$api01 + "/api/InfoCustomer/Attribute/QueryThHotCity";
      let resThHotCity = await fetch(getThHotCityUrl, {});
      if (resThHotCity.IsOK) {
        this.pickupCityData = resThHotCity.Results;
      }
    },
    //省市区接口
    async getProvDataApi(searchShow, text, take) {
      let getProvParam = {};
      let getProvUrl = "";
      /**
       * sysInfo 0:中文，1：英文
       * **/
      searchShow ? (getProvParam = { name: text, take: take, sysInfo: 0 }) : "";

      getProvUrl = this.$api02 + "/api/EbayCustomer/Province/QueryProvinceAndCity";

      let getProvData = await fetch(getProvUrl, getProvParam);
      if (!getProvData.IsOK) return;
      switch (searchShow) {
        case 1:
          //点击常用市，查询区域值
          getProvData.Results.forEach((k) => {
            k.CityList.forEach((m) => {
              this.ThAreaData = m.AreaList;
            });
          });
          this.sentMsgToService();
          break;
        case 2:
          console.log("进来u搜索");
          //搜索
          this.isSearchTxt = 5;

          // this.getProvSearch = getProvData.Results;
          this.getProvSearch = [];
          let city = {
            citySelName: "",
            ProvNameCh: "",
            AreaKey: "",
            CityKey: "",
            ProviceKey: "",
            dataList: {},
          };
          if (getProvData.Results.length > 0) {
            getProvData.Results.forEach((item, index) => {
              city.dataList = item;
              city.citySelName = item.Province.Province_NameCh;
              city.ProviceKey = item.Province.Id;
              city.ProvNameCh = item.Province.Province_NameCh;
              if (item.CityList.length == 1) {
                item.CityList.forEach((info) => {
                  city.citySelName =
                    item.Province.Province_NameCh + "/" + info.City_NameCh;
                  city.CityKey = info.Id;
                  if (info.AreaList.length == 1) {
                    info.AreaList.forEach((k) => {
                      city.citySelName =
                        item.Province.Province_NameCh +
                        "/" +
                        info.City_NameCh +
                        "/" +
                        k.CityArea_NameCh;
                      city.CityKey = k.Id;
                    });
                  }
                });
              }
            });

            this.getProvSearch.push(city);
          }

          break;
        default:
          //正常选择省市区
          this.ThProvData = getProvData.Results;
          console.log("正常选择省市区", this.ThProvData);
          //   Associated province
          //   localStorage.setItem('associatProvince', JSON.stringify(getProvData.Results))
          this.getProvSearch = [];
      }
      //   this.ThProvData = JSON.parse(localStorage.getItem('associatProvince'))
    },

    // 选中的常用的省市区

    clkCityText(item) {
      //保存数据
      this.CityDate.CityNameEn = item.NameEn;
      this.CityDate.CityKey = item.CityKey;
      this.CityDate.CityNameCh = item.NameCh;
      this.ProvDate.ProvNameCh = item.Province_NameCh;

      this.getProvDataApi(1, item.NameCh, 10);

      this.setTree(0, 1);

      this.ProvinceText = item.Province_NameCh;
      this.CityText = item.NameCh;
      this.CityDate.CountryKey = item.CityKey;
    },

    // 选中的省份
    clkPro(item) {
      console.log(item, "省份");
      this.ProvinceText = item.Province.Province_NameCh;

      //保存数据
      this.ProvDate.ProvNameEn = item.Province.Province_NameEn;
      this.ProvDate.ProvNameCh = item.Province.Province_NameCh;
      //选择省份后市区赋值
      this.ThCityList = item.CityList;
      this.CityDate.CountryKey = item.Province.Id;
      this.setTree(1);
    },
    clkCitySelect(item) {
      //选择城市

      //保存数据
      this.CityDate.CityNameEn = item.City_NameEn;
      this.CityDate.CityKey = item.Id;
      this.CityDate.CityNameCh = item.City_NameCh;

      //选择省份城市后区域赋值
      this.ThAreaData = item.AreaList;
      if (item.AreaList.length > 0) {
        this.CityText = item.City_NameCh;
        console.log("jinal");
        this.setTree();
      } else {
        console.log("sdsds");
        this.cityInput = this.ProvDate.ProvNameCh + "/" + item.City_NameCh;
        this.CityDateBF.CityKey = item.Country_Key;

        this.AreaData.AreaNameEn = "";
        this.AreaData.AreaNameCh = "";
        this.AreaData.AreaKey = "";

        this.setTree(1);
        this.sentMsgToService();
      }

      //
    },
    //选择城市区域
    clkAreaSelect(item) {
      this.cityInput =
        this.ProvDate.ProvNameCh +
        "/" +
        this.CityDate.CityNameCh +
        "/" +
        item.CityArea_NameCh;
      //保存数据
      //AreaData:{AreaNameEn:'',AreaNameCh:'',AreaKey:''},
      this.AreaData.AreaNameEn = item.CityArea_NameEn;
      this.AreaData.AreaNameCh = item.CityArea_NameCh;
      this.AreaData.AreaKey = item.Id;

      this.CityDateBF.CityNameEn = this.CityDate.CityNameEn;
      this.CityDateBF.CityKey = this.CityDate.CityKey;
      this.CityDateBF.CityNameCh = this.CityDate.CityNameCh;
      this.ProvDateBF.ProvNameCh = this.ProvDate.ProvNameCh;
      this.setTree();
      this.sentMsgToService();
    },

    //===========子组件传值到父组件=============//
    sentMsgToService() {
      let str = {
        menuCh: this.menuCh || "",
        ProvNameCh: this.ProvDateBF.ProvNameCh || this.ProvDate.ProvNameCh,
        CityNameCh: this.CityDateBF.CityNameCh || this.CityDate.CityNameCh,
        CityNameEn: this.CityDateBF.CityNameEn || "",
        CityKey: this.CityDateBF.CityKey || "",

        //区域
        CityAreaNameCh: this.AreaData.AreaNameCh || "",
        CityAreaNameEn: this.AreaData.AreaNameEn || "",
        CityAreaKey: this.AreaData.AreaKey,
      };
      this.$emit(
        "sentStartMsgSev",
        str,
        this.cityInput,
        this.menuNameChIdx,
        this.ThAreaData
      );
    },

    // 重置
    setTree(str, idx) {
      this.menuNameChIdx = [
        this.menuCh,
        this.ProvDate.ProvNameCh,
        this.CityDate.CityKey,
        this.AreaData.AreaKey,
      ];
      // console.log(
      //   "内容大小",
      //   (this.$parent.expandIsWidth = this.$refs.casPanel.offsetWidth)
      // );
      // console.log("this.menuNameChIdx", this.menuNameChIdx)
      switch (str) {
        case 0:
          //   this.ThProvData = []
          this.ThCityList = [];
          idx == 1 ? (this.ThAreaData = []) : "";

          break;
        case 1:
          //   this.pickupCityData = []
          this.ThAreaData = [];

          break;
        default:
          "";
      }
    },
    // 搜索内容点击
    clickSeach(item, index, data) {
      this.CityDate.CityNameCh = data.dataList.CityList[0].City_NameCh || "";
      this.CityDateBF.CityKey = data.CityKey || "";
      this.AreaData.AreaKey = data.AreaKey || "";
      this.$emit("clickSeach", item, index, data, this.ThProvData);
    },
  },
  mounted() {
    // 页面进入时加载内容
    bus.$on("closeClickInput", () => {
      this.showText = null;
    });

    this.getThHotCityApi();
    this.getProvDataApi();
  },
  watch: {
    // 监测变化
  },
};
</script>
<style scoped lang="scss">
.Cascader-panel {
}
.text-active-color {
  color: #0046b9 !important;
  cursor: pointer;
}
// 级联选择器
.selector-box {
  // position: absolute;
  //   max-width: 640px;
  z-index: 1;
  ::v-deep .el-scrollbar__bar.is-vertical {
    width: 4px !important;
  }

  ::v-deep  .el-scrollbar__bar.is-horizontal {
    left: 0 !important;
    display: none !important;
  }

  .scroll_menu {
    width: 224px;
    height: calc(208px - 16px);
    overflow-y: hidden;
    // ::v-deep  .el-scrollbar__wrap {
    //   overflow-x: hidden;
    // }
  }

  .scroll_menu_one {
    width: 151px;
    height: calc(208px - 16px);
    background: #fff;
    // ::v-deep  .el-scrollbar__wrap {
    //   overflow-x: hidden;
    // }
  }

  .divider_line {
    width: 1px;
    height: 100%;
    background: #dddddd;
    border-radius: 1px;
    // margin: 0 8px;
  }
  .selector-box-item {
    // position: absolute;
    height: 208px;
    background: #ffffff;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    padding: 8px 0;
    box-sizing: border-box;
    // max-width: 640px;
  }

  .selector-menu {
    width: calc(224px);
    // width: calc(224px - 16px);
    padding: 0 8px;
    box-sizing: border-box;
  }
  .selector-menu-one {
    // width: calc(151px + 8px);
    width: calc(151px);
    padding: 0 8px;
    box-sizing: border-box;
  }

  .selector-one-item {
    height: 32px;
    border-radius: 3px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    background: #fff;
    transition: all 0.5s;
    line-height: 16px;

    &:hover {
      background: #f7f8fa;
      border-radius: 3px;
      color: #0046b9;
      cursor: pointer;
      transition: all 0.5s;
      .font_c777 {
        color: #0046b9;
      }
    }
  }
}
</style>
